/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  isProgramError,
  type Address,
  type SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM,
  type SolanaError,
} from '@solana/kit';
import { DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS } from '../programs';

/** InvalidConfig: Invalid Rehype configuration */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_CONFIG = 0x1770; // 6000
/** InvalidBeneficiary: Invalid Rehype beneficiary */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_BENEFICIARY = 0x1771; // 6001
/** InvalidFeeRouting: Invalid fee routing matrix */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_FEE_ROUTING = 0x1772; // 6002
/** InvalidRoutingMode: Invalid routing mode */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_ROUTING_MODE = 0x1773; // 6003
/** InvalidLaunch: Invalid Initializer launch */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LAUNCH = 0x1774; // 6004
/** InvalidLaunchFeeState: Invalid launch fee state */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LAUNCH_FEE_STATE = 0x1775; // 6005
/** InvalidMint: Invalid mint */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_MINT = 0x1776; // 6006
/** InvalidTokenAccount: Invalid token account */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_TOKEN_ACCOUNT = 0x1777; // 6007
/** InvalidHookAccounts: Invalid hook remaining accounts */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_HOOK_ACCOUNTS = 0x1778; // 6008
/** ArithmeticOverflow: Arithmetic overflow */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__ARITHMETIC_OVERFLOW = 0x1779; // 6009
/** NoFeesAvailable: No fees are available */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__NO_FEES_AVAILABLE = 0x177a; // 6010
/** SettlementInProgress: Rehype settlement is already in progress */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__SETTLEMENT_IN_PROGRESS = 0x177b; // 6011
/** QuoteMismatch: Internal swap quote mismatch */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__QUOTE_MISMATCH = 0x177c; // 6012
/** BalanceMismatch: Internal swap balance mismatch */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__BALANCE_MISMATCH = 0x177d; // 6013
/** InvalidPhase: Launch phase does not support this settlement */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_PHASE = 0x177e; // 6014
/** UnclaimedFees: Beneficiary has unclaimed fees */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__UNCLAIMED_FEES = 0x177f; // 6015
/** UnauthorizedSettlement: Only the configured settlement authority may settle fees */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__UNAUTHORIZED_SETTLEMENT = 0x1780; // 6016
/** SlippageProtectionRequired: A positive minimum output is required for a fillable conversion */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__SLIPPAGE_PROTECTION_REQUIRED = 0x1781; // 6017
/** SlippageExceeded: Settlement conversion output is below the requested minimum */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__SLIPPAGE_EXCEEDED = 0x1782; // 6018
/** InvalidPool: Invalid migrated CPMM pool accounts */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_POOL = 0x1783; // 6019
/** InvalidPosition: Invalid Router CPMM position */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_POSITION = 0x1784; // 6020
/** InvalidLpRebalance: Invalid LP rebalance parameters */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LP_REBALANCE = 0x1785; // 6021
/** LpRebalanceWorsened: LP rebalance reduced the amount of liquidity that can be added */
export const DOPPLER_REHYPE_ROUTER_V1_ERROR__LP_REBALANCE_WORSENED = 0x1786; // 6022

export type DopplerRehypeRouterV1Error =
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__ARITHMETIC_OVERFLOW
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__BALANCE_MISMATCH
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_BENEFICIARY
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_CONFIG
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_FEE_ROUTING
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_HOOK_ACCOUNTS
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LAUNCH
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LAUNCH_FEE_STATE
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LP_REBALANCE
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_MINT
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_PHASE
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_POOL
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_POSITION
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_ROUTING_MODE
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_TOKEN_ACCOUNT
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__LP_REBALANCE_WORSENED
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__NO_FEES_AVAILABLE
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__QUOTE_MISMATCH
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__SETTLEMENT_IN_PROGRESS
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__SLIPPAGE_EXCEEDED
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__SLIPPAGE_PROTECTION_REQUIRED
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__UNAUTHORIZED_SETTLEMENT
  | typeof DOPPLER_REHYPE_ROUTER_V1_ERROR__UNCLAIMED_FEES;

let dopplerRehypeRouterV1ErrorMessages:
  | Record<DopplerRehypeRouterV1Error, string>
  | undefined;
if (process.env.NODE_ENV !== 'production') {
  dopplerRehypeRouterV1ErrorMessages = {
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__ARITHMETIC_OVERFLOW]: `Arithmetic overflow`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__BALANCE_MISMATCH]: `Internal swap balance mismatch`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_BENEFICIARY]: `Invalid Rehype beneficiary`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_CONFIG]: `Invalid Rehype configuration`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_FEE_ROUTING]: `Invalid fee routing matrix`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_HOOK_ACCOUNTS]: `Invalid hook remaining accounts`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LAUNCH]: `Invalid Initializer launch`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LAUNCH_FEE_STATE]: `Invalid launch fee state`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_LP_REBALANCE]: `Invalid LP rebalance parameters`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_MINT]: `Invalid mint`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_PHASE]: `Launch phase does not support this settlement`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_POOL]: `Invalid migrated CPMM pool accounts`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_POSITION]: `Invalid Router CPMM position`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_ROUTING_MODE]: `Invalid routing mode`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__INVALID_TOKEN_ACCOUNT]: `Invalid token account`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__LP_REBALANCE_WORSENED]: `LP rebalance reduced the amount of liquidity that can be added`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__NO_FEES_AVAILABLE]: `No fees are available`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__QUOTE_MISMATCH]: `Internal swap quote mismatch`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__SETTLEMENT_IN_PROGRESS]: `Rehype settlement is already in progress`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__SLIPPAGE_EXCEEDED]: `Settlement conversion output is below the requested minimum`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__SLIPPAGE_PROTECTION_REQUIRED]: `A positive minimum output is required for a fillable conversion`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__UNAUTHORIZED_SETTLEMENT]: `Only the configured settlement authority may settle fees`,
    [DOPPLER_REHYPE_ROUTER_V1_ERROR__UNCLAIMED_FEES]: `Beneficiary has unclaimed fees`,
  };
}

export function getDopplerRehypeRouterV1ErrorMessage(
  code: DopplerRehypeRouterV1Error,
): string {
  if (process.env.NODE_ENV !== 'production') {
    return (
      dopplerRehypeRouterV1ErrorMessages as Record<
        DopplerRehypeRouterV1Error,
        string
      >
    )[code];
  }

  return 'Error message not available in production bundles.';
}

export function isDopplerRehypeRouterV1Error<
  TProgramErrorCode extends DopplerRehypeRouterV1Error,
>(
  error: unknown,
  transactionMessage: {
    instructions: Record<number, { programAddress: Address }>;
  },
  code?: TProgramErrorCode,
): error is SolanaError<typeof SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM> &
  Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> {
  return isProgramError<TProgramErrorCode>(
    error,
    transactionMessage,
    DOPPLER_REHYPE_ROUTER_V1_PROGRAM_ADDRESS,
    code,
  );
}
